var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 52,
    viewBox: "0 0 166 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2154 20.378H54.8936V0H62.2154C68.3216 0 72.0792 3.81384 72.0792 10.189C72.0792 16.5501 68.3216 20.378 62.2154 20.378ZM59.5906 16.2687H62.0496C65.4757 16.2827 67.3545 14.608 67.3545 10.189C67.3545 5.75595 65.4757 4.09531 61.9944 4.08124H59.5906V16.2687Z",
    fill: "#272A36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2254 0V20.378H80.5283V0H85.2254Z",
    fill: "#272A36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.245 20.378H93.9232V0H101.245C107.351 0 111.109 3.81384 111.109 10.189C111.109 16.5501 107.351 20.378 101.245 20.378ZM98.6202 16.2687H101.079C104.505 16.2827 106.384 14.608 106.384 10.189C106.384 5.75595 104.505 4.09531 101.024 4.08124H98.6202V16.2687Z",
    fill: "#272A36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.785645 51.811V38.1349H5.86744C8.96882 38.1349 10.6223 40.0428 10.6316 42.6684C10.6223 45.2846 8.95014 47.183 5.83007 47.183H3.21444V51.811H0.785645ZM3.21444 45.1618H5.49377C7.32471 45.1524 8.14677 44.1135 8.14677 42.6684C8.14677 41.2045 7.32471 40.1939 5.49377 40.1939H3.21444V45.1618Z",
    fill: "#272A36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1591 51.811V38.1349H24.5879V49.7331H30.5664V51.811H22.1591Z",
    fill: "#272A36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3172 51.811H41.7202L46.4844 38.1349H49.4737L54.2565 51.811H51.6596L50.5293 48.4297H45.4381L44.3172 51.811ZM46.0921 46.4463H49.8754L48.0351 40.9306H47.923L46.0921 46.4463Z",
    fill: "#272A36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.187 40.1939V38.1349H73.9672V40.1939H69.8008V51.811H67.3721V40.1939H63.187Z",
    fill: "#272A36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4386 51.811V38.1349H94.1075V40.1939H87.8674V43.934H93.5097V45.993H87.8674V51.811H85.4386Z",
    fill: "#272A36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.798 44.9729C117.807 49.3931 115.135 51.9999 111.595 51.9999C108.036 51.9999 105.383 49.3837 105.392 44.9729C105.383 40.5528 108.036 37.946 111.595 37.946C115.135 37.946 117.807 40.5528 117.798 44.9729ZM107.84 44.9729C107.83 48.0992 109.39 49.7898 111.595 49.7898C113.809 49.7898 115.359 48.0992 115.35 44.9729C115.359 41.8467 113.809 40.1561 111.595 40.1561C109.39 40.1561 107.83 41.8467 107.84 44.9729Z",
    fill: "#272A36"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.531 51.811V38.1349H134.612C137.714 38.1349 139.367 39.8917 139.377 42.4984C139.367 44.359 138.526 45.738 136.938 46.3897L139.862 51.811H137.153L134.5 46.8052H131.959V51.811H129.531ZM131.959 44.7463H134.239C136.07 44.7557 136.892 43.9624 136.892 42.4984C136.892 41.0439 136.07 40.1939 134.239 40.1939H131.959V44.7463Z",
    fill: "#272A36"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.035 38.1349H154.024L158.041 48.0708H158.209L162.226 38.1349H165.215V51.811H162.88V42.404H162.749L158.994 51.7732H157.256L153.501 42.3662H153.389V51.811H151.035V38.1349Z",
    fill: "#272A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoP);
export default __webpack_public_path__ + "static/media/logo-p.cc6b1ef10a3e2a717bd9e362339b10a5.svg";
export { ForwardRef as ReactComponent };